<template>
  <div class="dashboard-container">
    <div class="app-container">学科添加</div>
  </div>
</template>

<script>
export default {
  name: 'SubjectsAdd',
  data() {
    return {}
  }
}
</script>

<style scoped>
</style>
